import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import * as stylex from '@stylexjs/stylex'
import { ButtonBase } from '../ButtonBase/ButtonBase'
import { colors } from '../tokens/colors.stylex'
import { type XStyles } from '../useXStyles/useXStyles'
import { useXStyles } from '../useXStyles/useXStyles'
import { useCarousel } from './useCarousel'

const _baseStyles = stylex.create({
  root: {
    gap: '0.5rem',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    transform: 'translateX(-50%)',
    bottom: 6,
    left: '50%',
  },
  dot: {
    borderColor: colors.grey500,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    transition: 'background-color 0.2s',
    backgroundColor: {
      'default': colors.grey300,
      ':hover': colors.grey500,
    },
    opacity: 0.8,
    height: 10,
    width: 10,
  },
  dotActive: {
    backgroundColor: colors.grey500,
  },
})

export interface PageIndicatorsProps {
  xStyles?: Partial<XStyles<keyof typeof _baseStyles>>
  maxIndicator?: number
  onDotClick?: (index: number) => void
}

export const PageIndicators = (props: PageIndicatorsProps) => {
  const { xStyles, maxIndicator, onDotClick } = props
  const { totalPages, currentPage, goToPage } = useCarousel()
  const baseStyles = useXStyles(_baseStyles, xStyles)

  const handleDotClick = useCallbackEvent((index: number) => () => {
    onDotClick?.(index)
    goToPage(index)
  })

  return (
    <div {...stylex.props([baseStyles.root, xStyles?.root])}>
      {[...Array(maxIndicator ?? totalPages)].map((_, index) => (
        <ButtonBase
          key={index}
          disableRipple
          onClick={handleDotClick(index)}
          rootStyle={[baseStyles.dot, currentPage === index && baseStyles.dotActive, xStyles?.dot]}
        />
      ))}
    </div>
  )
}
